export const truncate = (path) => (
    typeof path !== 'string' ? path : path.replace(/0x[a-f\d]{40,}/ig, (match) => (
        `${match.substr(0, 5)}...${match.substring(match.length - 5)}`
    ))
)
